import * as React from 'react';
import Card from './Card';
import ActionButtons, { ActionButton } from './ActionButtons';
import '../css/add-on-service-card.sass';

interface AddOnServiceCardProps {
  name: string;
  nameLabel?: string;
  theme?: 'night' | 'day';
  buttons: ActionButton[];
}
export default function AddOnServiceCard(props: AddOnServiceCardProps) {
  const { theme = 'day' } = props;
  return (
    <div className="add-on-service-card">
      <Card theme={theme}>
        <div className="name">{props.name}</div>
        {props.nameLabel && (
          <div className="price-label">{props.nameLabel}</div>
        )}
        <div className="service-btn">
          <ActionButtons
            key="actionButtonAddOnServiceCard"
            buttons={props.buttons}
          />
        </div>
      </Card>
    </div>
  );
}
